/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /*
   * Вид для страницы организатора совместных покупок
   */
  app.JointPurchaseOrganizerPageView = app.View.extend({
    events: {
      'click .js-toggle': 'toggleAddresses',
      'click .js-jp-settlement': 'selectSettlement',
      'click .js-select-organizer-button': 'selectOrganizer',
      'click .js-organizer-info-more': 'toggleOrganizerInfo',
    },

    el: '.js-organizer-profile',

    run: function () {
      var organizerData = app.helpers.TemplateHelper.getJson('#organizer-json');
      var purchaseData = app.helpers.TemplateHelper.getJson('#purchase-json');

      this.deliveryAddresses = app.helpers.TemplateHelper.getJson('#organizer-delivery-address-json');
      this.deliveryPickups = app.helpers.TemplateHelper.getJson('#organizer-delivery-pickups-json');

      this.settlements = this.createSettlementsArray();

      this.conditionTemplate = app.helpers.TemplateHelper.getTemplate('#organizer-conditions-template');
      this.informationTemplate = app.helpers.TemplateHelper.getTemplate('#organizer-information-template');
      this.deliveryConditionTemplate = app.helpers.TemplateHelper.getTemplate('#organizer-delivery-conditions-template');
      this.paymentsTemplate = app.helpers.TemplateHelper.getTemplate('#organizer-payments-template');
      this.selectButtonTemplate = app.helpers.TemplateHelper.getTemplate('#select-button-template');

      this.model = new app.JointPurchaseOrganizer(organizerData);
      this.purchaseModel = new app.Model(purchaseData);
      this.render();

      var organizerId = this.model.get('id');
      this.updateSelectButton(this.getCurrentOrganizerId() === organizerId);

      this.initChildViews();
    },

    /**
     * Собираем массив с поселениями из массивов доставок и самовывозов.
     */
    createSettlementsArray: function () {
      var deliverySettlements = this.deliveryAddresses.map(function (address) {
        return address.settlement;
      });
      var pickupSettlements = this.deliveryPickups.map(function (address) {
        return address.settlement;
      });
      var settlements = _.union(deliverySettlements, pickupSettlements);
      // Убираем дубликаты
      settlements = _.uniqBy(settlements, function (settlement) {
        return settlement.id;
      });
      // Сортируем по имени
      settlements = _.sortBy(settlements, [function(settlement) {
        return settlement.name;
      }]);

      return settlements;
    },

    /**
     * Первичный рендер информации об организаторе
     */
    render: function () {
      var settlementId = this.user.get('settlement_id') || null;
      var settlement = this.findSettlementBySettlementId(settlementId);

      this.$('.js-jp-conditions').html(this.conditionTemplate({
        minRequestSum: this.model.get('min_request_sum'),
        settlements: this.settlements,
        isPrepayment: this.model.get('is_prepayment')
      }));
      this.renderOrganizerInformation();
      if (settlement) {
        this.renderCurrentSettlement(settlement);
        this.renderDeliveryData(settlement.id);
        this.initPopup();
      }

      this.renderPaymentData();
    },

    /**
     * Инициализация попапа со скроллом
     */
    initPopup: function () {
      if (this.settlements.length > 1) {
        this.popup = new als.Popup($('.js-settlement-popup'), $('.js-popup-toggle'));

        var arrow = this.$('.js-arrow');
        this.popup.addEventListener(
          als.Popup.EventType.BEFORE_OPEN, function () {
            arrow.addClass('with-icon_arrowup-blue');
          }
        );
        this.popup.addEventListener(
          als.Popup.EventType.BEFORE_CLOSE, function () {
            arrow.removeClass('with-icon_arrowup-blue');
          }
        );
      }
    },

    /**
     * Инициализация дочерних вью
     */
    initChildViews: function () {
      if (this.purchaseModel.get('id')) {
        this.childViews.jpTimerView = new app.JointPurchaseTimerView({
          model: this.purchaseModel,
          el: $('.jp-aside-info'),
          organizerId: this.model.get('id')
        });
      }

      if (this.settlements){
        this.childViews.tabsView = new app.TabsBaseItemView({
          el: this.$el
        });
      }
    },

    /**
     * Отрисовка информации о доставке
     * @param settlementId {number}
     */
    renderDeliveryData: function (settlementId) {
      var deliveries = this.findDeliveriesBySettlementId(this.deliveryAddresses, settlementId);
      var districts = this.getSortedDistrictsPrices(deliveries);

      var addresses = this.findDeliveriesBySettlementId(this.deliveryPickups, settlementId);

      this.$('.js-delivery-conditions').html(this.deliveryConditionTemplate({
        addresses: addresses,
        districts: districts,
        maxAddressesPerList: 4,
      }));
    },

    /**
     * Отрисовка информации о наценке, предоплате и типах оплаты
     */
    renderPaymentData: function () {
      var payments = this.model.get('payments');
      var prepayments = this.model.get('prepayments');
      var paymentTypes = this.model.get('paymentTypes');
      var paymentTypesString = '';

      if (_.isArray(paymentTypes)) {
        paymentTypesString = paymentTypes
          .map(function (paymentType) {
            return paymentType.name;
          })
          .join(', ');
      }

      this.$('.js-payments-conditions').html(this.paymentsTemplate({
        payments: payments
      }));
      if (this.model.get('is_prepayment')) {
        this.$('.js-prepayments-conditions').html(this.paymentsTemplate({
          payments: prepayments
        }));
      }
      this.$('.js-payment-types').html(paymentTypesString);
    },

    /**
     * Обновить имя выбранного города
     * @param settlement {Object}
     */
    renderCurrentSettlement: function (settlement) {
      var name = settlement.name + ' (' + settlement.region + ')';
      $('.js-current-settlement').html(name);
    },

    /**
     * Отрисовка данных организатора и контактов
     */
    renderOrganizerInformation: function () {
      var startDate = moment(this.model.get('userCreatedAt'));
      var workingPeriod = moment.duration(Date.now() - startDate.valueOf());
      var months = parseInt(workingPeriod.asMonths(), 10);
      var purchases = parseInt(this.model.get('purchaseNumber'), 10);
      var contacts = this.model.prepareContactsArray();
      var organizerInfo = this.model.get('organizer_info');

      this.$('.js-organizer-info-block').html(this.informationTemplate({
        monthsNumber: months,
        purchasesNumber: purchases,
        monthsText: app.helpers.DeclinationHelper.format(months, ['месяц', 'месяца', 'месяцев']),
        purchasesText: app.helpers.DeclinationHelper.format(
          purchases,
          ['совершённая закупка', 'совершённые закупки', 'совершённых закупок']
        ),
        contacts: contacts,
        organizerInfo: organizerInfo
      }));
    },

    /**
     * Скрывает/показывает часть информации от организатора.
     */
    toggleOrganizerInfo: function () {
      this.$('.js-organizer-info').toggleClass('not_display');
    },

    /**
     * Найти доставки в городе по айди города
     * @param deliveriesArray {Array}
     * @param settlementId {Number}
     * @returns {Array}
     */
    findDeliveriesBySettlementId: function (deliveriesArray, settlementId) {
      var settlementIndex = _.findIndex(deliveriesArray, function (delivery) {
        return delivery.settlement.id === settlementId;
      });
      var deliveries = [];
      if (settlementIndex !== -1 && deliveriesArray.length){
        deliveries = deliveriesArray[settlementIndex].deliveries;
      }
      return deliveries;
    },

    /**
     * Найти город в массиве городов по айди
     * @param settlementId {Number}
     * @returns {Object}
     */
    findSettlementBySettlementId: function (settlementId) {
      var settlementIndex = _.findIndex(this.settlements, function (settlement) {
        return settlement.id === settlementId;
      });
      if (settlementIndex < 0) {
        settlementIndex = 0;
      }
      return this.settlements[settlementIndex] || null;
    },

    /**
     * Получить объект с отсортированными по цене районами доставки. Ключ - цена. Значение - строка с районами.
     * @param districts {Array}
     * @returns {Object} or {null}
     */
    getSortedDistrictsPrices: function (districts) {
      if (!districts || !districts.length) {
        return null;
      }

      var result = {};
      districts.forEach(function group(district) {
        var key = district.price;

        if (result[key]) {
          result[key] = result[key] + ', ' + district.district_name;
        } else {
          result[key] = district.district_name;
        }
      });

      return result;
    },

    /**
     * Свернуть и развернуть список адресов доставки
     */
    toggleAddresses: function () {
      this.$('.js-to-hide ').toggleClass('not_display');
    },

    /**
     * Выбор города из списка в попапе
     * @param e
     */
    selectSettlement: function (e) {
      var settlementId = parseInt(e.currentTarget.dataset.id, 10);
      this.renderDeliveryData(settlementId);

      var settlement = this.findSettlementBySettlementId(settlementId);
      this.renderCurrentSettlement(settlement);
    },

    /**
     * Обработка нажатия на кнопку "Выбрать организатора"
     * @param e
     */
    selectOrganizer: function (e) {
      var button = $(e.currentTarget);
      button.attr('disabled', true);

      var organizerId = this.model.get('id');
      var currentOrganizer = this.getCurrentOrganizerId();
      //Если текущий уже выбран, сбрасываем
      if (currentOrganizer === organizerId) {
        organizerId = null;
      }

      this.user.saveJpOrganizer(
        organizerId,
        {
          success: function () {
            button.attr('disabled', false);
            var currentOrganizer = this.getCurrentOrganizerId();
            this.updateSelectButton(this.model.get('id') === currentOrganizer);
          }.bind(this)
        }
      );
    },

    /**
     * Обновить состоянии кнопки "Выбрать организатора"
     * @param isSelected
     */
    updateSelectButton: function (isSelected) {
      this.$('.js-select-organizer-button').html(this.selectButtonTemplate({
        isSelected: isSelected
      }));
    },

    /**
     * Получить айди текущего выбранного организатора из модели пользователя или куки
     * @returns {Number|null}
     */
    getCurrentOrganizerId: function () {
      return this.user.get('selected_jp_organizer_id') || app.helpers.CookieHelper.getCookie('my_jp_organizer') || null;
    }
  });
})(jQuery);

}.call(window));